const inputTextLimit = 250;
const inputDescLimit = 10000;
const emailSubjectLimit = 255;
const fieldEmailTester = /^(?!.*[._%+-]{2})[A-Z0-9](?:[A-Z0-9._%+-]*[A-Z0-9])?@[A-Z][A-Z0-9.-]*\.[A-Z]{2,6}$/i




const validateEmail = (email) => {
  if (!fieldEmailTester.test(email)) {
    return true;
  }
  const domain = email.split('@')[1].toLowerCase();

  if (domain.startsWith('gmail') && domain !== 'gmail.com') {
    return true;
  }

  return false;
};


export { inputTextLimit, inputDescLimit, emailSubjectLimit, validateEmail };
